import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class ANPrivatVersicherung extends AdornisEntity {
  static override _class = 'ANPrivatVersicherung';

  @Field(() => Boolean, { default: v => v ?? false })
  istPrivatVersichert: Maybe<boolean>;

  @Field(() => ID)
  letzteGesKrankenkasseID: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  anspruchKrankentageGeld: Maybe<boolean>;

  @Field(() => Int, { default: v => v ?? 0 })
  krankenBeitrag: Maybe<number>;

  @Field(() => Int, { default: v => v ?? 0 })
  pflegenBeitrag: Maybe<number>;

  @Field(() => ID)
  arbeitgeberzuschussID: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  isPrivatPflegeversichert: Maybe<boolean>;

  @Field(() => Float)
  beitragsanteilBasisKrankenversicherung: Maybe<number>;
}
